"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthInterceptor = void 0;
const axios_1 = require("axios");
const auth_1 = require("../../../auth");
const constants_1 = require("../../constants");
class AuthInterceptor {
    constructor(clientConfig, axiosInstance) {
        this.registerWhen = (clientConfig) => {
            return !!(clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.authConfig);
        };
        this.runWhen = (config) => {
            return this.isDomainAllowed(config);
        };
        this.onRequest = async (config) => {
            const token = await this.tokenProvider.getToken();
            config.headers.Authorization = `Bearer ${token}`;
            return config;
        };
        this.onError = async (error) => {
            var _a;
            if (!this.isDomainAllowed(error.config)) {
                return Promise.reject(error);
            }
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) !== axios_1.HttpStatusCode.Unauthorized) {
                return Promise.reject(error);
            }
            if (error.config._authRetried) {
                return this.userUnauthorizedHandler(error);
            }
            const token = await this.tokenProvider.getToken(true);
            error.config.headers.Authorization = `Bearer ${token}`;
            error.config._authRetried = true;
            return this.instance.request(error.config);
        };
        if (!(clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.authConfig)) {
            return;
        }
        this.tokenProvider = new auth_1.ClientAuthStrategy(clientConfig.authConfig);
        this.instance = axiosInstance;
    }
    async userUnauthorizedHandler(error) {
        const options = error.config;
        if (options.unauthorizedHandler) {
            await options.unauthorizedHandler();
        }
        if ('auth' in window && !options.disableLogout) {
            const { auth } = window;
            auth.logout();
            auth.redirectToAuthPage();
        }
        else {
            Promise.reject(error);
        }
    }
    isDomainAllowed(config) {
        try {
            const url = new URL(config.url, config.baseURL);
            return constants_1.AUTH_ALLOWED_TOP_LEVEL_DOMAINS.some(domain => url.hostname.endsWith(domain));
        }
        catch {
            return false;
        }
    }
}
exports.AuthInterceptor = AuthInterceptor;
